<div class="input-license-wrapper" [class.disabled]="isDisabled" [class.small]="isSmall">
  <div class="input-license-header-line">
    <div class="input-license-check-box-container">
      <mat-checkbox [checked]="isSelected" [disabled]="isDisabled"></mat-checkbox>
      <div class="input-license-check-box-overlap"></div>
    </div>

    <nimbus-mat-icon-overlay class="input-license-info-overlay" [icon]="ICONS.INFO_CIRCLE_LIGHT">
      <div class="input-license-provisioning-text-body large">
        <span class="provision-text">{{ infoLabel }}</span>
      </div>
    </nimbus-mat-icon-overlay>
  </div>

  <img class="input-license-image" [src]="image" alt="" />
  <div class="input-license-label">
    @if (beta) {
      <i [nimbusIcon]="ICONS.FLASK"></i>
    }
    {{ label }}
  </div>

  @if (isDisabled) {
    <nimbus-tooltip [text]="disabledReasonsList"></nimbus-tooltip>
  }
</div>
